<template>
  <div class="web-004-home-index">
    <pc v-if="!isMobile" />
    <mobile v-else />
  </div>
</template>

<script>
import pc from './pc.vue';
import mobile from './mobile.vue';
export default {
    name: 'Web004',
    components: {
        pc,
        mobile,
    },
    computed: {
        isMobile () {
            return (/Mobi|Android|iPhone/i.test(navigator.userAgent));
        },
    },
};
</script>

<style scoped lang="scss">
.web-004-home-index {
    width: 100%;
    min-height: calc(100vh - 160px);
}
</style>
